/** @jsx jsx */
import { jsx } from '@emotion/core'
import TrendMenu from './TrendMenu'
import { Route } from 'react-router-dom'
import { getMetrics } from '../selectors'
import { connect } from 'react-redux'
import { trendElements } from './trend-spec'
import TrendChart from './TrendChart'
import R from 'ramda'
import { Content, FullHeightSizer } from 'core/screen-util'
// const Container = styled.div`
//   padding-left: 1em;
//   padding-right: 1em;
// `

const specToRoute = spec => {
  const { id } = spec
  return (
    <Route
      key={`${id}-trend-content`}
      path={`/trend/detail/${id}`}
      render={_ => <TrendChart spec={spec} />}
    />
  )
}

const TrendContainer = ({ metrics }) => {
  const createRoutes = R.compose(
    R.map(specToRoute),
    R.filter(m => m),
    R.map(m => metrics[m])
  )

  return (
    <FullHeightSizer heightOffset={170}>
      {({ height }) => (
        <Content css={{ height: height - 20, paddingTop: '10px', minHeigh: height }}>
          <TrendMenu
            style={{
              position: 'absolute',
              right: '15px',
              maxHeight: height - 40,
              overflowY: 'auto',
            }}
          />
          {createRoutes(trendElements)}
        </Content>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  metrics: getMetrics(state),
})

export default connect(mapStateToProps)(TrendContainer)
